import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { LogIn, Trophy, AlertCircle } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Button } from "../../components/ui/button";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [u, setU] = useState("");
  const [p, setP] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(u, p);
      navigate("/admin");
    } catch (e) {
      setErr(e?.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#0a1226] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-7">
          <div className="inline-flex items-center gap-2.5">
            <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-amber-400 to-amber-600 flex items-center justify-center"><Trophy className="w-6 h-6 text-[#0a1226]" strokeWidth={2.5} /></div>
            <div className="text-2xl font-extrabold text-white">OnlineCricketID<span className="text-amber-400">.guru</span></div>
          </div>
          <p className="mt-3 text-slate-400 text-sm">Admin Panel — sign in to manage your site</p>
        </div>
        <form onSubmit={onSubmit} className="card-dark p-6 md:p-7">
          {err && <div className="mb-4 flex items-start gap-2 text-sm text-rose-300 bg-rose-500/10 border border-rose-500/30 rounded-lg p-3"><AlertCircle className="w-4 h-4 mt-0.5" /> {err}</div>}
          <div className="space-y-4">
            <div>
              <Label className="text-slate-300">Username</Label>
              <Input value={u} onChange={(e) => setU(e.target.value)} placeholder="admin" autoComplete="username" className="mt-1.5 bg-[#0c1530] border-white/10 text-white placeholder:text-slate-500 focus-visible:ring-amber-500" />
            </div>
            <div>
              <Label className="text-slate-300">Password</Label>
              <Input type="password" value={p} onChange={(e) => setP(e.target.value)} placeholder="••••••••" autoComplete="current-password" className="mt-1.5 bg-[#0c1530] border-white/10 text-white placeholder:text-slate-500 focus-visible:ring-amber-500" />
            </div>
            <Button type="submit" disabled={loading} className="btn-gold border-0 w-full py-5 rounded-xl">
              {loading ? "Signing in..." : (<><LogIn className="w-4 h-4 mr-1.5" /> Sign In</>)}
            </Button>
          </div>
        </form>
        <p className="text-center text-xs text-slate-500 mt-4">© {new Date().getFullYear()} OnlineCricketID.guru Admin</p>
      </div>
    </div>
  );
}
